<template>
<div class="ddd">测试</div>

</template>


<script>
  export default {
    name: 'login',
    data() {
      return {
        userinfo: {}

      }
    },
    mounted() {
       var mytoken = this.getQueryString("mytoken");
       if (mytoken) {
           this.tologinapi(mytoken);
       }
    },
    methods: {
      getQueryString:function (name) {
         var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
         var r = window.location.search.substr(1).match(reg);
         if (r != null) return unescape(r[2]); return null;
      },
     tologinapi: function(mytoken) {
        var vm = this;
        if (mytoken) {
          var data = {
              params: {}
          };
          var url = "https://www.flw.ph/plugin.php?id=zimu_fenlei&model=my&op=myinfo&token=" + mytoken;
          vm.$axios.get(url, data).then((res) => {

          }).catch((err) => {

          })
          return false;
        }
       },
    }
  }
</script>


<style>
  .ddd{
    background-color: red;
    width: 100px;
    height: 100px;
    margin: auto;
    margin-top: 200px;
  }

</style>



// WEBPACK FOOTER //
// src/page/login.vue